export default "__VITE_ASSET__Wtj3WfVC__"